var iconColorRoles = [
  "primary",
  "secondary",
  "tertiary",
  "accent",
  "danger"
];
export {
  iconColorRoles
};
//# sourceMappingURL=iconRoles.js.map
